import { render, staticRenderFns } from "./MiniPlayer.vue?vue&type=template&id=1f6044f0&scoped=true"
import script from "./MiniPlayer.vue?vue&type=script&lang=js"
export * from "./MiniPlayer.vue?vue&type=script&lang=js"
import style0 from "./MiniPlayer.vue?vue&type=style&index=0&id=1f6044f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6044f0",
  null
  
)

export default component.exports